export default __webpack_public_path__ + "static/Press_Release_Milan_Laser_Miami_Swim_Week-57b3df57976da5500dc83e7018117153.pdf";